import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { clearSelectNodeEpic } from './_epics/clearSelectNode.epic';
import { toggleSelectNodeEpic } from './_epics/toggleSelectNode.epic';
import { initSymbolPoolEpic } from './_epics/initSymbolPool.epic';

export const symbolPoolEpic = safeCombineEpics(
  toggleSelectNodeEpic,
  clearSelectNodeEpic,
  initSymbolPoolEpic,
);
